import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import {
	getAvgOkrReport,
	getMostWeeklyKrReport,
	getMostFeedbackReport,
	getWeeklyKrGrowthReport,
	getLeastRiskOkrReport,
	getLeastRiskKrReport,
	getTeamPerformance,
	getTeamProgressDetails,
	getLeadingTeamsDetails,
	getOrgReportsDetails,
	getOkrProgressDetails,
	getEngagementOverallProgress,
	getTeamOkrProgressDetails,
	getTeamEngagementOverallProgress,
	getLeadingTeamsReports,
	getMyLeadingTeamsDetails,
	resetLeadingTeam,
} from '../../action/report';
import Reports from '../../components/Reports';
import { updatePage, updateRoute, showLoader, updatePrevRoute, currentDashboardTab } from '../../action/common';
import { resetAlignment } from '../../action/alignment';
import { resetFeedback, requestOneToOneFeedback } from '../../action/feedback';
import {
	getOkrMasterData,
	fetchProgressReport,
	fetchFeedbackReport,
	fetchStatusReport,
	fetchQuarterReport,
	getStatusReport,
} from '../../action/myGoal';

const mapStateToProps = (state) => {
	return {
		feedbackOneOnOneStatus: state.feedbackReducer.feedback1To1Status,
		currentRoute: state.commonReducer.currentRoute,
		okrNatures: state.okrReducer.okrMasterData,
		leadingTeams: state.reportsReducer.leadingTeam,
		orgReport: state.reportsReducer.orgReport,
		orgReportStatus: state.reportsReducer.orgReportStatus,
		leadingTeamsReport: state.reportsReducer.leadingTeamsReport,
		myLeadingTeams: state.reportsReducer.myLeadingTeams,
		userSelectedCycle: state.commonReducer.userSelectedCycle,
		dashboardCurrentTab: state.commonReducer.dashboardCurrentTab,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getAvgOkrReport,
			getMostWeeklyKrReport,
			getMostFeedbackReport,
			getWeeklyKrGrowthReport,
			getLeastRiskOkrReport,
			getLeastRiskKrReport,
			// resetOkr,
			resetAlignment,
			resetFeedback,
			updatePage,
			updateRoute,
			requestOneToOneFeedback,
			showLoader,
			updatePrevRoute,
			getTeamPerformance,
			getTeamProgressDetails,
			getOkrMasterData,
			getLeadingTeamsDetails,
			getOrgReportsDetails,
			getOkrProgressDetails,
			getEngagementOverallProgress,
			getTeamOkrProgressDetails,
			getTeamEngagementOverallProgress,
			getLeadingTeamsReports,
			getMyLeadingTeamsDetails,
			resetLeadingTeam,
			currentDashboardTab,
			fetchProgressReport,
			fetchFeedbackReport,
			fetchStatusReport,
			fetchQuarterReport,
			getStatusReport,
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Reports));
